/* Page-level sale hooks for the UTC offer box. Reads the live sale state the box publishes on
   #uo-offer (data-uo-sale-*). Elements: [data-uo-sale-only] shown only while a sale is active,
   [data-uo-timer] is always hidden (no urgency), [data-uo-sale-pct|name|gifts] text, [data-uo-sale-cta]
   button label forced to "Start My Plan". */
(function () {
  'use strict';
  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  function each(sel, fn) {
    var l = document.querySelectorAll(sel);
    for (var i = 0; i < l.length; i++) { fn(l[i]); }
  }
  function tick() {
    var ob = document.getElementById('uo-offer');
    var attr = function (n) { return (ob && ob.getAttribute(n)) || ''; };
    var pct = parseInt(attr('data-uo-sale-pct'), 10) || 0;
    var on = attr('data-uo-sale-active') === '1' && pct > 0;
    each('[data-uo-sale-only]', function (el) { el.hidden = !on; });
    each('[data-uo-timer], [data-uo-timer-wrap]', function (el) { el.hidden = true; });
    each('[data-uo-sale-pct]:not(#uo-offer):not(.uo-anchor)', function (el) { el.textContent = String(pct); });
    each('[data-uo-sale-name]:not(#uo-offer):not(.uo-anchor)', function (el) { el.textContent = attr('data-uo-sale-name') || 'The Fall Reset'; });
    each('[data-uo-sale-gifts]:not(#uo-offer):not(.uo-anchor)', function (el) { el.textContent = attr('data-uo-sale-gifts') || '3'; });
    each('[data-uo-sale-cta]', function (el) {
      if (document.querySelector('[data-uo-context="pdp"]')) { return; }
      var t = 'Start My Plan';
      if (el.textContent !== t) { el.textContent = t; }
    });
  }
  function init() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
